/**
 * Import all front-end JS scripts.
 * 
 * Compiles to assets/scripts/theme-scripts.js
 */

 /* eslint-disable no-unused-vars */

import './base/main-navigation.js';
import './base/gov-notice.js';
import './base/publications.js';
import './base/search.js';
import "../../../blocks/accordion/accordion.js";
import "../../../blocks/hero-slider/hero-slider.js";
import "../../../blocks/tabs/tabs.js";
